export class CreateSiteParam {
    anaplanFeasyId: string;
    anaplanFeasyName: string;
    area: string;
    masterCommunityId: number;
}
